import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api/client';
import { serviceAreaEndpoints } from '@/lib/api/endpoints';
import { serviceAreaKeys, onboardingKeys } from '@/lib/queryKeys';
import type { CreateOperationsServiceArea } from '@/types/service-area';

interface Input {
  zipCode: string;
  city: string;
  state: string;
}

/**
 * Creates a service area in operations only (no scheduler, no tax lookup).
 * Use this when the tax zone lookup has already been handled separately.
 */
export function useCreateOpsServiceArea() {
  const qc = useQueryClient();

  return useApiMutation<void, Input>({
    mutationFn: ({ zipCode, city, state }) => {
      const payload: CreateOperationsServiceArea = {
        areaType: 'zip',
        stateCode: state,
        city,
        zipCode,
      };
      return apiPost(operationsClient, serviceAreaEndpoints.create(), payload).then(
        () => undefined,
      );
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: serviceAreaKeys.all() });
      void qc.invalidateQueries({ queryKey: onboardingKeys.all() });
    },
  });
}
